<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div>
            <router-link class="btn btn-md btn-dark" :to="{ name: 'cat-cupones-apl-nuevo' }">
              <i class="fas fa-angle-double-left sliding-icon"></i>
              &nbsp;Regresar
            </router-link>
            <div class="element-actions" style="float: right;">
              <div class="btn-group">
                <button :disabled="!current.id" aria-expanded="false" aria-haspopup="true"
                  class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" type="button">
                  <i class="fa fa-cogs"></i>
                  Acciones
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                  <button @click="dar_de_baja()" class="dropdown-item" type="button" :disabled="!isActive()">
                    <i class="fas fa-user-slash"></i>
                    &nbsp;Dar de Baja
                  </button>
                  <button @click="abrirModalEstatics" type="button" class="dropdown-item">
                    <i class="fas fa-eye"></i> &nbsp;Ver movimientos
                  </button>
                </div>
              </div>
            </div>
          </div>
          <br>
          <div class="element-wrapper">
            <form class="element-box" @submit.prevent="guardar" style="background-color: #e2e8d7;">
              <div class="row">
                <div class="col-2"></div>
                <div class="col-8">
                  <!--Sección que muestra si cuenta conun ID-->
                  <div class="element-box" v-if="!current.id" id="crearRegistro">
                    <h5>
                      Añadir Beneficio a Empleado&nbsp;
                      <i class="fas fa-user-plus"></i>
                    </h5>
                    <div class="form-desc">Complete el formulario para la asignación.</div>
                  </div>
                  <!--Sección que muestra si cuenta con ID-->
                  <div class="element-box" id="mostrarRegistro" style="text-align: center;" v-if="current.id">
                    <h5>
                      Beneficio Descuento Empleado
                    </h5>
                    <span style="font-size: 15px;">
                      <i class="fas fa-id-card"></i>&nbsp; {{ current.nombre }}
                    </span>
                    <br>
                    <span class="badge" v-bind:class="{
                      'badge-success': isActive(),
                      'badge-danger': !isActive(),
                    }">
                      <div v-if="isActive()">ACTIVO</div>
                      <div v-if="!isActive()">INACTIVO</div>
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-2"></div>
                <div class="element-box row col-8" style="background-color:white;">
                  <div class="col-6">
                    <label>CUI de beneficiario</label>
                    <input :disabled="current.id" type="text" v-model="current.identificacion" class="form-control"
                      data-toggle="tooltip" data-placement="top" title="DPI sin espacios" />
                  </div>
                  <div class="col-6">
                    <label>Nombre de beneficiario</label>
                    <input type="text" v-model="current.nombre" class="form-control" />
                  </div>
                  <div class="col-4">
                    <label v-bind:class="{
                      'text-danger': current.errors && current.errors.tienda,
                    }">Tipo de Empleado</label>
                    <select :disabled="current.id" class="form-control" v-model="current.tipo_oferta">
                      <option selected value="I">INTERNO</option>
                      <option value="E">EXTERNO</option>
                    </select>
                    <small v-if="current.errors && current.errors.tipo_oferta" class="form-text text-danger">{{
                      current.errors.tipo_oferta[0] }}</small>
                    <br />
                  </div>
                  <div class="col-4">
                    <label>Fecha Inicio de Beneficio</label>
                    <input type="date" class="form-control" v-model="current.fecha_inicio" :disabled="current.id"
                      data-toggle="tooltip" data-placement="top" title="Fecha sugerida (Hoy)" />
                    <small class="text-danger" v-if="current.errors && current.errors.fecha_inicio">{{
                      current.errors.fecha_inicio }}</small>
                  </div>

                  <div class="col-4">
                    <label>Fecha Fin de Beneficio</label>
                    <input type="date" class="form-control" v-model="current.fecha_fin" :disabled="current.id"
                      data-toggle="tooltip" data-placement="top" title="Fecha sugerida para fin de beneficio" />
                    <small class="text-danger" v-if="current.errors && current.errors.fecha_fin">{{
                      current.errors.fecha_fin }}</small>
                  </div>
                  <div class="col-6">
                    <ListasPrecioSelectComponent :current="current" data-toggle="tooltip" data-placement="top"
                      title="Lista sugerida: 13 - Empleados" />
                    <small class="text-danger" v-if="current.errors && current.errors.lista_precio">{{
                      current.errors.lista_precio[0] }}</small>
                    <br />
                  </div>
                  <div class="col-6">
                    <label>Límite de Uso</label>
                    <input type="text" class="form-control" v-model="current.max_cant_usos" :disabled="current.id"
                      data-toggle="tooltip" data-placement="top" title="Cantidad en números" placeholder="100" />
                    <small class="text-danger" v-if="current.errors && current.errors.max_cant_usos">{{
                      current.errors.max_cant_usos[0] }}</small>
                  </div>
                </div>
              </div>
              <div class="form-buttons-w" style="text-align: center;">
                <button v-if="!current.id" class="btn btn-md btn-success" type="submit">
                  Crear Registro &nbsp;<i class="fas fa-check"></i>
                </button>
                <button v-if="current.id" class="btn btn-md btn-dark" type="submit">
                  Guardar Cambios &nbsp;<i class="fas fa-save"></i>
                </button>
              </div>
              <div style="float: right;" v-if="current.id">
                <b>Creado por: {{ current.usuario_obj.username }}</b>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div aria-hidden="true" class="modal fade" id="ModalAplCupon" role="dialog" tabindex="-1">
      <div class="modal-dialog modal-xl" role="document" style="max-width: 100%">
        <div class="modal-content modal-xl" style="max-width: 100%">
          <div class="modal-header faded">
            <h5 class="modal-title">
              <span style="font-size: 23px; color: black;">
                Movimientos y Estadísticas de Uso
              </span>
              <br>
              <span style="font-size: 14px;">
                <i class="fas fa-user-circle"></i> {{ current.nombre }}
              </span>
              <br>
              <span style="font-size: 14px;">
                &nbsp;&nbsp;&nbsp;{{ current.id }}
              </span>
            </h5>
            <button class="btn btn-danger" @click="cerrarModal()" data-dismiss="modal" type="button">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <br>
          <div class="modal-body">
            <div class="table-responsive">
              <!-------------------- Tabla de REsultados -------------------->
              <table class="table table-hover table-striped">
                <thead class="thead-dark">
                  <tr>
                    <th class="text-center">Facturas Aplicadas</th>
                    <th class="text-center">Tiempo de Uso</th>
                    <th class="text-center">Monto Min.</th>
                    <th class="text-center">Monto Máx.</th>
                    <th class="text-center">Promedio de Monto</th>
                    <th class="text-center">Promedio Gasto Mensual</th>
                    <th class="text-center">Monto Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="dataTabla.length === 0">
                    <td class="text-center" colspan="7">- - - - - - - - No hay datos disponibles - - - - - - - -</td>
                  </tr>
                  <tr v-for="det in dataTabla" v-bind:key="det.id" style="font-size: 13.5px">
                    <td class="text-center">
                      {{ det.cant_tickets }}
                    </td>
                    <td class="text-center">{{ det.meses }} Meses</td>
                    <td class="text-center">Q {{ det.min_ticket_gastado_GTQ.toFixed(2) }}</td>
                    <td class="text-center">Q {{ det.max_ticket_gastado_GTQ.toFixed(2) }}</td>
                    <td class="text-center">Q {{ det.ticket_promedio_GTQ.toFixed(2) }}</td>
                    <td class="text-center">Q {{ det.gasto_promedio_mensual_GTQ.toFixed(2) }}</td>
                    <td class="text-center">Q {{ det.total_comprado_GTQ.toFixed(2) }}</td>
                  </tr>
                </tbody>
              </table>
              <!-------------------- END - Basic Table -------------------->
            </div>
            <hr />
            <div class="table-responsive" style="overflow-y: scroll; max-height: 300px" ref="tablaResultados">
              <!-------------------- Tabla de REsultados -------------------->
              <table class="table table-striped table-hover">
                <thead class="thead-dark">
                  <tr>
                    <th class="text-center">Tienda</th>
                    <th class="text-center">No. Factura</th>
                    <th class="text-center">Fecha Aplicación</th>
                    <th class="text-right">Total de Factura</th>
                    <th class="text-center">Forma de Pago</th>
                    <th class="text-right">Total pagado</th>
                    <th class="text-right">Ver</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="dataTablaLista.length === 0">
                    <td class="text-center" colspan="7"> - - - - - - - - - - - Aún no hay movimientos con este código -
                      - - - - - - - - - -</td>
                  </tr>
                  <tr v-for="det in dataTablaLista" v-bind:key="det.id" style="font-size: 13.5px">
                    <td class="text-center">
                      {{ det.nombre_tienda }}
                    </td>
                    <td class="text-center">
                      <span>{{ det.numero }}</span>
                    </td>
                    <td class="text-center">
                      {{ det.fecha_creacion | moment("DD/MM/YYYY HH:mm:ss") }}
                    </td>
                    <td class="text-right">Q. {{ det.valor_total.toFixed(2) }}</td>
                    <td class="text-center">
                      {{ det.forma_pago_id }}
                    </td>
                    <td class="text-right">Q. {{ det.total_pagado.toFixed(2) }}</td>
                    <td class="text-right">
                      <router-link :to="{
                        name: 'cxc-cargos-editar',
                        params: { id: det.cargo_e_id },
                      }" target="_blank" class="btn btn-outline-dark btn-sm">
                        <i class="fas fa-external-link-square-alt"></i>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-------------------- END - Basic Table -------------------->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
import ListasPrecioSelectComponent from "@/components/commons/ListasPrecioSelectComponent";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
  components: {
    TiendaSelectComponent,
    UsuariosSelectComponent,
    ListasPrecioSelectComponent,
  },
  data() {
    return {
      estatus: true,
      tarea_tipo: "",
      current: {
        identificacion: null,
        tipo_oferta: "I",
        estado: "A",
        estatus: true,
        fecha: "",
        fecha_inicio: "",
        fecha_fin: "",
        usuario_obj: "",
        errors: null
      },
      dataTablaLista: [],
      errors: {
        identificacion: "",
      },
      dataTabla: [],
      detalle: {},
      tipos_liq: [],
      tiendas: [],
      currentDetalle: {},
      tiendas: "",
    };
  },
  computed: {},
  mounted() {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    let self = this;
    if (this.$route.params.id) {
      self.refreshCurrent();
      self.refreshListaComprasAPL();
    } else {
      self.current.fecha_inicio = moment().format("YYYY-MM-DD");
      self.current.fecha_fin = "9999-12-31";
    }
  },
  methods: {
    refreshestadistica() {
      let self = this;
      DynamicService.getAction(
        "cat",
        "lista-precio-cupon",
        this.$route.params.id,
        "promedio_uso_por_colaborador"
      ).then((response) => {
        self.dataTabla = response.data;
        console.log(self.dataTabla);
      });
    },

    refreshListaComprasAPL() {
      let self = this;
      DynamicService.getAction(
        "cat",
        "lista-precio-cupon",
        this.$route.params.id,
        "lista_de_compras_apl_cupon"
      ).then((response) => {
        self.dataTablaLista = response.data;
        console.log(self.dataTabla);
      });
    },
    abrirModalEstatics() {
      let self = this;
      $("#ModalAplCupon").modal("toggle");
      self.refreshestadistica();
    },
    dar_de_baja() {
      let self = this;
      Notifications.alert.confirm(
        "¿Esta seguro que desea darle de baja?",
        "",
        "",
        function () {
          DynamicService.postAction(
            "cat",
            "lista-precio-cupon",
            self.current.id,
            "dar_de_baja"
          )
            .then((response) => {
              Notifications.alert.success(
                "Beneficio Descuento",
                "¡Se dió de baja al beneficio exitosamente!"
              );
              self.refreshCurrent();
            })
            .catch((errors) => {
              self.current.errors = errors.response.data;
            });
        }
      );
    },
    guardar() {
      let self = this;
      let _current = Object.assign({}, self.current)
      if (_current.identificacion == '' || !_current.identificacion) {
        Notifications.alert.error("Lista Precio Cupón", "Ingrese un Identificador válido");
      }
      if (_current.fecha_fin) {
        _current.fecha_fin = moment(_current.fecha_fin).format("DD/MM/YYYY");
      }
      if (_current.fecha_inicio) {
        _current.fecha_inicio = moment(_current.fecha_inicio).format(
          "DD/MM/YYYY"
        );
      }
      if (_current.lista_precio) {
        _current.lista_precio = _current.lista_precio.id;
      }
      DynamicService.save("cat", "lista-precio-cupon", _current)
        .then((response) => {
          Notifications.alert.success("¡Éxito!", "El beneficio a empleado fue añadido correctamente.");
          self.$router.push({
            name: "cat-cupones-apl-editar",
            params: { id: response.data.id },
          });
          self.refreshCurrent();
        })
        .catch((errors) => {
          self.current.errors = errors.response.data;
        });
    },
    refreshCurrent() {
      let self = this;
      DynamicService.getById("cat", "lista-precio-cupon", this.$route.params.id).then(
        (response) => {
          self.current = response.data;
          self.current.fecha_inicio = moment(
            response.data.fecha_inicio,
            "DD/MM/YYYY"
          ).format("YYYY-MM-DD");
          self.current.fecha_fin = moment(self.current.fecha_fin, "DD/MM/YYYY").format(
            "YYYY-MM-DD"
          );
          self.current.estado = "B";
          self.estatus = true;
        }
      );
    },
    isActive() {
      const today = moment().startOf('day');
      const fechaFin = moment(this.current.fecha_fin, "YYYY-MM-DD");
      return fechaFin.isAfter(today);
    },
    cerrarModal() {
      let self = this;
      $("#ModalAplCupon").modal("toggle");
    },
  },
};
</script>
